import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Text from '../../Text/Text';
import Button from '@material-ui/core/Button';
import ApealCitationFormData from './AppealCitationFormData';
import ReactQuillEditor from '../../Card/ReactQuill/ReactQuillEditor';
import { appealCitation } from '../../../store/citationDetail/action';
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux';
import { getAppealFineHeaderEditorSelector } from '../../../store/profile/selector';
import { useParams } from 'react-router-dom';
import { getAppealFineHeaderEditorDataAction } from '../../../store/profile/action';
const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    title: {
        fontWeight: 'bold',
        marginTop: '10px',
        fontSize: 14,
    },
    TextField: {
        width: '100%'
    }
}));

export default function ApealCitationForm(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { customer } = useParams();
    const UserParams = useParams();
    const appealFineHeaderEditorData = useSelector(getAppealFineHeaderEditorSelector);

    React.useEffect(() => {
        if (customer) {
            dispatch(getAppealFineHeaderEditorDataAction(customer))
        }
    }, [customer]);

    const { handleClose } = props;
    const [form, setform] = useState({
        citationId: props.citationId || String(props?.citationDetailState?.id) || "20000020",
        appealText: "",
        appealFromName: "",
        appealFromEmail: "",
        groupName: UserParams.customer,
    });
    const [error, setError] = useState({
        citationId: false,
        appealText: false,
        appealFromName: false,
        appealFromEmail: false
    });

    const handleChange = (e) => {
        setError({ ...error, [e.target.name]: e.target.value === "" ? true : false });
        setform({ ...form, [e.target.name]: e.target.value });
    }
    
    const handleSubmit = (e) => {
        let errorTmp = { ...error };
        let isValidate = true;
        // let groupName = UserParams.customer;
        Object.keys(errorTmp).forEach((val) => {
            if (form[val] === "") {
                errorTmp[val] = true;
                isValidate = false;
                // groupName = groupName
            }
        });
        setError(errorTmp);
        if (isValidate) { dispatch(appealCitation(form)); props.handleCloseAppealCitationModal(true) };
    }

    return (
        <div className={classes.root}>
            <Grid container spacing={3} align='left'>
                <Grid item xs={6}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Grid container>
                                <Grid item xs={12}>
                                    <Text
                                        align={'left'}
                                        className={classes.title}
                                        name={"appealFromName"}
                                        value={form.appealFromName}
                                        error={error.appealFromName}
                                        onChange={handleChange}
                                    >
                                        Driver Name :
                                    </Text>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        id="standard-basic"
                                        type="text"
                                        name={"appealFromName"}
                                        className={classes.TextField}
                                        value={form.appealFromName}
                                        error={error.appealFromName}
                                        onChange={handleChange}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container>
                                <Grid item xs={12}>
                                    <Text
                                        align={'left'}
                                        className={classes.title}
                                    >
                                        Email Address:
                                    </Text>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        id="standard-basic"
                                        className={classes.TextField}
                                        type="email"
                                        placeholder="email"
                                        name={"appealFromEmail"}
                                        value={form.appealFromEmail}
                                        error={error.appealFromEmail}
                                        pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}\.com"
                                        onChange={handleChange}
                                        required
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Text
                                align={'left'}
                                className={classes.title}
                                value={form.appealText}
                                error={error.appealText}
                                name="appealText"
                                onChange={handleChange}
                            >
                                Appeal Reason
                            </Text>
                        </Grid>
                        <Grid item xs={12}>
                            <ReactQuillEditor handleChange={(html) => {
                                setform({ ...form, ['appealText']: html })
                            }} />
                        </Grid>
                        <Grid>
                            <i>Note:  Verify all information before submitting.  You will not be able to make any changes after submission</i>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={6}>
                    <div>
                        {appealFineHeaderEditorData && appealFineHeaderEditorData.text != '' ? (
                            <div
                                className="ql-editor"
                                style={{ color: "black" }}
                                dangerouslySetInnerHTML={{ __html: appealFineHeaderEditorData }}
                            />
                        ) : (
                            ""
                        )}
                    </div>
                </Grid>
                <Grid item xs={6}>
                    <Grid container spacing={3} >
                        <Grid item xs={6}>
                            <Button onClick={handleClose}>Cancel</Button>
                        </Grid>
                        <Grid item xs={6}>
                            {form.appealFromName !== '' && form.appealFromEmail !== '' && form.appealText !== '' ?
                                <Button variant="contained" color="primary" onClick={handleSubmit} >
                                    Submit Appeal
                                </Button>
                                : <Button variant="contained" disabled color="primary" onClick={handleSubmit} >
                                    Submit Appeal
                                </Button>}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    );
}


